<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Draudžiami paslaugų teikėjai') }}</h1>
   
    <!-- add button  -->
    <el-button
      class="mb-5"
      color="primary"
      icon="pridėti"
      title="Pridėti paslaugų teikėją"
      :loading="loading"
      @click.native.stop="newItem()"
    />
    <!-- search -->
    <blacklist-search
      :loading="loading"
      @search="searchBlacklist"
    />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :item-class="rowClass"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template #[`item.roles`]="{ item }">
        <el-table-classifier :item="item.roles" list listBreak :classifier="tableClassifiers.roles" />
      </template>
      <!--main custom templates -->
      <template #[`item.status`]="{ item }">
        <el-busena :busena="item.status" />
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            @deleteItem="deleteItem(item)"
          />
        </div>
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <!-- modals -->
     <modal-add-person
      v-if="showAddPerson"
      v-model="showAddPerson"
      :modalType="modalType"
      mandate
      @addPersonData="AddPerson"
    />
    <modal-delete
      title="Šalinti įrašą"
      text="Ar tikrai norite pašalinti įrašą?"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import ModalDelete from '@/components/modals/ModalDelete'
import tableParameters from '@/mixins/tableParameters'
import BlacklistSearch from './AdminBlacklistSearch'
import ModalAddPerson from '@/components/modals/ModalAddPerson'

export default {
  name: 'Blacklist',
  components: {
    ModalDelete,
    BlacklistSearch,
    ModalAddPerson,
  },
  mixins: [userRole, tableParameters],
  data() {
    return {
      pageloading: true,
      loading: false,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteItem: null,
      listData: [],

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 10,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      tableClassifiers: [],
      modalType: null,
      showAddPerson: null,
      searchData: {},
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Paslaugų teikėjo: JA kodas / FA kodas'),
          align: 'start',
          value: 'code',
        },
          {
          text: this.$t('Paslaugų teikėjo: JA pavadinimas / FA vardas pavardė'),
          align: 'start',
          value: 'title',
        },
        {
          text: this.$t('Galioja nuo'),
          align: 'start',
          value: 'valid_from',
          width: "8rem"
        },
        {
          text: this.$t('Galioja iki'),
          align: 'start',
          value: 'valid_to',
          width: "7rem"
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  beforeDestroy() {
 
  },
  created() {
    // this.setlistParams()
    this.getClassifiers()
  },
  methods: {
     searchBlacklist(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(searchData.btn)
    },
    newItem() {
      this.modalType = 'blacklist'
      this.showAddPerson = true
    },
    getClassifiers() {
      this.pageloading = true
      let requiredClassifiers = { classifiers: ['roles'] }
      this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.tableClassifiers = res.data.classifiers
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      this.setSortParams()

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`forbidden-action-providers/list`, data)
        .then((res) => {
          this.listData = res.data.forbiddenActionProviders
          this.pagination = { ...this.pagination, ...res.data.pagination }

        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
          page: pagination.page,
          route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    AddPerson(item) {
      this.pageloading = true
      this.$axios.post(`forbidden-action-providers`, item)
      .then((res) => {
        this.showAddPerson = false
        this.getData()
      })
      .catch((err) => {
        this.$root.$emit('DATA_ERROR', err)
      })
      .finally(() => {
        this.pageloading = false
      })
    },
    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`forbidden-action-providers/${item.id}`)
        .then((res) => {
          this.$root.$emit('DATA_OK_CODE', '000111')
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.showDelete = false
        })
    },

    rowClass(item) {
      if (item.status === 'warning') {
        return `status-warning`
      }
      if (item.status === 'outdate') {
        return `status-outdate`
      }
      if (item.status === 'repost') {
        return `status-repost`
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
